import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-0da93eb4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "search"
};
const _hoisted_2 = {
  class: "result"
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  class: "title"
};
const _hoisted_6 = {
  class: "desc"
};
const _hoisted_7 = {
  class: "result"
};
const _hoisted_8 = {
  class: "result"
};

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "item",
  style: {
    "cursor": "initial",
    "background-color": "initial"
  }
}, [/*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "Нет результатов...")], -1));

const _hoisted_10 = [_hoisted_9];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LoupeIcon = _resolveComponent("LoupeIcon");

  const _component_SpinnerComponent = _resolveComponent("SpinnerComponent");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_withDirectives(_createElementVNode("input", {
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.searchName = $event),
    onKeyup: _cache[1] || (_cache[1] = _withKeys($event => $data.searchName && _ctx.$router.push({
      name: 'search',
      query: {
        q: $data.searchName
      }
    }), ["enter"])),
    onInput: _cache[2] || (_cache[2] = (...args) => $options.search && $options.search(...args)),
    placeholder: "Поиск...",
    type: "text"
  }, null, 544), [[_vModelText, $data.searchName]]), _createVNode(_component_LoupeIcon, {
    class: "loupe",
    width: "17",
    height: "17",
    onClick: _cache[3] || (_cache[3] = $event => $data.searchName && _ctx.$router.push({
      name: 'search',
      query: {
        q: $data.searchName
      }
    }))
  }), _withDirectives(_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "item",
    onClick: _cache[4] || (_cache[4] = $event => _ctx.$router.push({
      name: 'search',
      query: {
        q: $data.searchName
      }
    }))
  }, [_createElementVNode("div", _hoisted_3, "Смотрите полные результаты для \"" + _toDisplayString($data.searchName) + "\"", 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.searchResult, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      onClick: $event => _ctx.$router.push($options.getToForRouterLink(item)),
      class: "item"
    }, [_createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_6, _toDisplayString(item.type), 1)], 8, _hoisted_4);
  }), 128))], 512), [[_vShow, !$data.loading && $data.searchResult.length]]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createVNode(_component_SpinnerComponent)], 512), [[_vShow, $data.loading]]), _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_10, 512), [[_vShow, !$data.loading && !$data.searchResult.length && $data.searchName]])]);
}